import { FiArrowRight } from "react-icons/fi";
import { LoaderFunction, useLoaderData } from "remix";
import { ButtonLink } from "~/components/Button";
import { ContentBlock } from "~/components/ContentBlock";
import { ContentBlockModel, getContentBlock } from "~/utils/contentBlocks";
import { getUserId } from "~/utils/session.server";

interface LoaderData {
  title: ContentBlockModel;
  content: ContentBlockModel;
  editable: boolean;
}

export const loader: LoaderFunction = async ({ request, params }) => {
  const [title, content, userId] = await Promise.all([
    getContentBlock(`${params.festivalSlug}/title`),
    getContentBlock(`${params.festivalSlug}/content`),
    getUserId(request),
  ]);

  return {
    title,
    content,
    editable: userId !== null,
  };
};

export default function FestivalIndex() {
  const { title, content, editable } = useLoaderData<LoaderData>();

  return (
    <>
      <article>
        <h1 className="text-3xl md:text-6xl font-bold my-8">
          <ContentBlock block={title} editable={editable} />
        </h1>

        <ContentBlock block={content} editable={editable} />
      </article>
      <div className="my-10">
        <ButtonLink to="events">
          Zu den Veranstaltungen <FiArrowRight className="ml-2" />
        </ButtonLink>
      </div>
    </>
  );
}
